<app-page-header [header]="'offer.' + (isAppTravelAgency ? 'travel-agency-title': 'title')" />
<ng-container *ngIf="quotationState$ | async as quotationState">
  <div class="save-backoffice-toast-container"
  [ngClass]="{ 'sticky-navigation': !(isOfferPriceBoxVisible$ | async) && (currentStep$ | async) === 2}">
    <nx-message *ngIf="showToolboxMessage" context="success" closable (close)="showToolboxMessage = false"
      class="save-backoffice-toast">
      <div>
        <span>
          {{ 'offer.toolbox.save-backoffice-section-toast' | translate }}
        </span>
      </div>
    </nx-message>
    <qbe-tabs-group *ngIf="(quotationState !== apiState.error) && (quotationData$ | async)"
      [selectedTab]="(selectedTab$ | async) || 0" (tabChanged)="changeTab($event)">
      <qbe-tabs *ngFor="let offerPackage of (offerPackages$ | async); let i = index" [label]="offerPackage.name"
        [description]="(getPackageDescription(offerPackage) | async) || '—'"
        [badge]="offerPackage.highlighted ? (((isResignation$ | async) ? 'offer.tabs-badge-resignation' : 'offer.tabs-badge') | translate) : ''">
        <app-offer-content [showToolbox]="showToolbox" />
      </qbe-tabs>
    </qbe-tabs-group>
    <qbe-toolbox *ngIf="(quotationState$ | async) === apiState.success && showToolbox" class="backoffice-toolbox">
      <qbe-toolbox-group>
        <app-dynamic-input [formGroup]="backofficeForm" name="premiumPercentDecrease" inputType="number" min="1"
          max="99" label="offer.toolbox.premiumPercentDecrease"
          suffix="modals.change-premium.form.premium.suffix"></app-dynamic-input>
        <app-dynamic-input [formGroup]="backofficeForm" name="premiumPercentIncrease" inputType="number" min="1"
          max="999" label="offer.toolbox.premiumPercentIncrease"
          suffix="modals.change-premium.form.premium.suffix"></app-dynamic-input>
        <app-dynamic-input [formGroup]="backofficeForm" name="postingOnAgentBehalf" inputType="checkbox"
          label="offer.toolbox.postingOnAgentBehalf"></app-dynamic-input>
        <ng-container *ngIf="backofficeForm.controls.postingOnAgentBehalf.value">
          <app-dynamic-input [formGroup]="backofficeForm" name="impersonateAgentNumber" inputType="number"
            label="offer.toolbox.impersonateAgentNumber"></app-dynamic-input>
          <div class="agent-data-text">
            {{backofficeForm.controls.agentData.value}}
          </div>
        </ng-container>

        <app-dynamic-input [formGroup]="backofficeForm" name="specialContractTerms" inputType="checkbox"
          label="offer.toolbox.specialContractTerms"></app-dynamic-input>

        <app-dynamic-input *ngIf="backofficeForm.controls.specialContractTerms.value" [formGroup]="backofficeForm"
          name="specialContractTermsText" inputType="textarea" [maxRows]="4" maxLength="5000"
          label="offer.toolbox.specialContractTermsText"></app-dynamic-input>
      </qbe-toolbox-group>
      <qbe-toolbox-footer>
        <button nxButton="secondary" type="button"
          [disabled]="backofficeForm.controls.postingOnAgentBehalf.value && backofficeForm.controls.impersonateAgentNumber.invalid"
          (click)="saveBackOfficeSection()">
          {{ 'offer.toolbox.btn' | translate }}
        </button>
      </qbe-toolbox-footer>
    </qbe-toolbox>
  </div>
  <app-error *ngIf="quotationState === apiState.error" [appError]="quotationError$ | async" />
  <app-loader *ngIf="!(quotationData$ | async)" />
</ng-container>